module.exports = __webpack_public_path__ + "static/media/arrow-back-blue.adb28e2a.svg";